import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AdditionalIncomeSource } from 'src/app/models/Argyle';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { IncomeSourceModalComponent } from '../income-source-modal/income-source-modal.component';
import { ScreeningLight, Screening } from 'src/app/models/screeningInvite';
import { take, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-income-source-list',
  templateUrl: './income-source-list.component.html',
  styleUrls: ['./income-source-list.component.less']
})
export class IncomeSourceListComponent implements OnInit{
  @Input() incomeSources: AdditionalIncomeSource[] = []
  @Input() public screening : Screening;
  @Input() applicantName : string;
  @Input() showSnapptToggle : boolean = false;
  @Output() public hasUnverifiedIncome: EventEmitter<boolean> = new EventEmitter<boolean>();
  public incomeUpdatedInList: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  // @Output() public saved : EventEmitter<boolean> = new EventEmitter<boolean>();
  private modalRef1: NgbModalRef | null = null;

  constructor(public appdata: ApplicantDataService, private modalService: NgbModal, public toast: ToastrService, public auth: AuthService) { }
  ngOnInit(): void {
    if(this.incomeSources.length == 0)
    {
        this.loadSources();
    }
  }

  editSource(src: AdditionalIncomeSource) {
    this.modalRef1 = this.modalService.open(IncomeSourceModalComponent, { centered: true, size: 'lg' })
    this.modalRef1.componentInstance.name = 'IncomeSourceModalComponent';
    this.modalRef1.componentInstance.screeningId = this.screening.id;
    this.modalRef1.componentInstance.applicantName = this.applicantName;
    this.modalRef1.componentInstance.sourceTypes = this.appdata.incomeSourceTypes;
    this.modalRef1.componentInstance.showSnapptToggle = this.showSnapptToggle;
    this.modalRef1.componentInstance.newSource = src;
    this.modalRef1.componentInstance.saved.subscribe((dta: boolean) => {
      this.loadSources();
    });
    this.modalRef1.componentInstance.closed.subscribe((dta : boolean)=>{
      this.modalRef1.close();
    })
  }

  getSourceTypeName(id: number)
  {
    return this.appdata.incomeSourceTypes.find(st => {return st.id == id;}).name;
  }

  loadSources() {
    this.appdata.GetAdditionalIncomeSources(this.screening.id).pipe(take(1), tap((_: AdditionalIncomeSource[]) => {
      this.incomeSources = _;
      if(this.incomeSources.some(src => !src.incomeVerified)) {
        this.hasUnverifiedIncome.emit(true);
      } else this.hasUnverifiedIncome.emit(false);
    })).subscribe();
  }
  
   
  removeSource(src: AdditionalIncomeSource)
  {
    this.appdata.RemoveIncomeSource(src).subscribe((scc: boolean)=>{
      if(scc)
        this.toast.success('Successfully removed income source');
      else 
        this.toast.error('Error removing income source');
    },(err: any)=>{
      this.toast.error('Error removing income source');
    },()=>{
      this.loadSources();
    })

  }
}
